import React, { Component } from 'react';
import cx from 'classnames';
import history from '../../../browserHistory';
import mapInterface from '../../../mapboxgl/mapInterface';
import Footer from 'components/ViewWrapperContainer/ViewWrapper/Footer/Footer';
import './MapWrapper.scss';

class MapWrapper extends Component {
  constructor() {
    super();
    this.state = {
      invalidToken: false,
    };
    this.invalidToken = this.invalidToken.bind(this);
  }
  componentDidMount() {
    const {
      addControls: mapControls,
      analytics,
      mapStyle,
      mapRendering,
      tourId,
      mapToken,
    } = this.props;
    // if account has no mapboxgl token, falls back to the default from env vars
    let mapTokenExistsOnAccount = mapToken || process.env.REACT_APP_MAPBOXGL;

    mapInterface.renderMap(
      {
        container: this.mapContainer,
        mapControls,
        analytics,
        mapStyle,
        mapRendering,
        tourId,
        mapToken: mapTokenExistsOnAccount,
      },
      this.invalidToken
    );
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      this.props.mapStyle !== nextProps.mapStyle ||
      (!this.state.invalidToken && nextState.invalidToken) ||
      this.props.path !== nextProps.path
    );
  }

  componentDidUpdate(prevProps, prevState) {
    const { mapStyle, tourId, mapRendering } = this.props;
    // if the user is previewing after just saving a new mapStyle via RedirectModal we need to update the mapStyle
    if (mapStyle !== prevProps.mapStyle) {
      mapInterface.updateMapStyle(mapStyle, tourId, mapRendering);
    }

    if (!prevState.invalidToken && this.state.invalidToken) {
      history.push('/token/error/404');
    }
  }

  invalidToken(error) {
    if (error.status === 403) {
      this.setState({ invalidToken: true });
    }
  }

  render() {
    const { children, tier, path, miniMapView } = this.props;
    const isMapHidden =
      path.includes('/hotspots-manager') || path.includes('/edit/styles');
    const isMiniMap = miniMapView === 'map';
    const mapClasses = cx({
      'cms-view': !path.includes('/view') && !path.includes('/share'),
      'main-view': !isMiniMap,
      'minimap-view': isMiniMap,
      hidden: isMapHidden,
      edit: path.includes('/edit') && !path.includes('/edit/stop/'), // adds the edit class on refresh as mapEl is null in CDM on TourEditor
      starter: tier === 'starter',
    });
    return (
      <>
        <section
          id="map"
          className={mapClasses}
          ref={el => (this.mapContainer = el)}
          data-cy={`${
            isMiniMap ? 'minified-map' : 'maximized-map'
          }`}
          aria-label={`${
            isMiniMap ? 'Mini map' : 'map content'
          }`}
        >
          {children}
        </section>
        {path.match(/(\/stops|\/general)/) && <Footer />}
      </>
    );
  }
}

export default MapWrapper;
